import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import './sass/mystyles.scss'


//importing pages
import Home from './components/Home.vue'
import Contact from './components/Contact.vue'

Vue.use(VueRouter)

const routes = [
  {path: '/', component: Home},
  {path: '/contact', component: Contact}
]

const router = new VueRouter({
  routes: routes
})

Vue.config.productionTip = false

new Vue({
  el: "#app",
  router: router,
  render: h => h(App)
}).$mount('#app')
